import React from 'react';

const FraudExperience: React.FC = () => {

  return (
    <section className="tw-bg-black tw-text-white tw-pt-24 tw-pb-32">
      <div className="tw-flex tw-justify-center tw-px-4 tw-mx-auto tw-mb-24">
        <div className="tw-max-w-2xl tw-w-full">
          <h2 className="tw-text-4xl md:tw-text-6xl tw-font-bold">
            You’ve got 100+ reasons to believe.
          </h2>
          <p className="tw-text-lg md:tw-text-2xl tw-text-gray-400 tw-mt-4 tw-font-bold">
            Our merchants are our partners. Like Jai had Veeru, and Krishna had Arjun —{" "}
            <span className="tw-text-[#FF3333]"> we’ve got you. </span>
             With over 100 trusted partnerships, we work side by side to help you grow your business and deliver great experiences to your customers.
          </p>
        </div>
      </div>


    </section>
  );
};

export default FraudExperience;
